'use client';

import { useGlobalClientContext } from '../common/GlobalClientContext';
import CheckFillIcon from '../icons/Checked.outline.green';

export default function InterestComplete() {
  const {
    i18nHelper: { t }
  } = useGlobalClientContext();

  return (
    <div className="flex flex-col mt-[98px] items-center justify-start gap-[40px]">
      <div>
        <div className="w-[142px] h-[142px] flex items-center justify-center bg-success-100 rounded-full border-[22px] border-solid border-success-50">
          <CheckFillIcon />
        </div>
      </div>
      <div className="flex flex-col items-center justify-start gap-[12px]">
        <span className="font-semibold text-2xl leading-4xl text-primary">
          {t('interest.complete.title', {})}
        </span>
        <div className="flex flex-col items-center justify-start font-regular text-sm leading-lg text-primary">
          <span>{t('interest.complete.description', {})}</span>
          <span>{t('interest.complete.description2', {})}</span>
        </div>
      </div>
    </div>
  );
}
